import { createSlice } from '@reduxjs/toolkit';

export const viewCart = createSlice({
  name: 'viewCart',
  initialState: {
    data: '',
  },

  reducers: {
    setViewCart: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setViewCart } = viewCart.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getViewCart = (state) => {
  return state.viewCart.data;
};

export default viewCart.reducer;
